module.exports = __webpack_public_path__ + "img/game-screenshot.44728598.png";